import "bootstrap-icons/font/bootstrap-icons.css";

import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { eligibility } from "constants/eligibility";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";

import outline_check from "assets/images/outline_check.svg";

function CashlinePersonal() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Personal Financing-i"
          title={`  <span className="jumbotron-subtitle-2">
                Cashline</span><em>-i</em>
             `}
          buttonText="Let's connect! "
          //   footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              alrajhi bank Malaysia offers Cashline-i, a Shariah-compliant
              flexible financial solution to help you better manage your
              finances. With Cashline-<i>i</i>, you can access cash anytime you
              need it. This financing option allows you to easily draw, pay, and
              redraw funds from the Current Account-<i>i</i> (CA-<i>i</i> ) you
              hold with alrajhi bank Malaysia, up to the approved limit. Enjoy
              the convenience of Cashline-<i>i</i> and stay financially flexible
              with us.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Attractive rates</div>
                <div className="column-subheader-2">
                  As low as low as SBR* + 6.50%
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Tenure</div>
                <div className="column-subheader-2">Up to 8 years.</div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Flexible Withdrawal</div>
                <div className="column-subheader-2">
                  via Cheque, Debit Card, Internet Banking, or from any of our
                  branches.
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Fee</div>
                <div className="column-subheader-2">Zero Commitment Fee. </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Collaterals</div>
                <div className="column-subheader-2">No collaterals needed.</div>
              </div>
            </div>
            <p className="pt-3">*Terms and conditions apply</p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Shariah Contract</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">
                  Commodity Murabahah (via Tawarruq arrangement)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitycashline.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
            <div className="link-button-row pt-5">
              <LinkButton
                text={
                  <span>
                    Cashline-<em>i</em> Application Form
                  </span>
                }
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/Cashline-i Application Form.pdf`
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS - Retail Cashline-i (1).pdf`
                  )
                }
              />
            </div>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default CashlinePersonal;
